import { memo } from "react";

import Chip from "@mui/material/Chip";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import type {
  QuestionnairePayload,
  QuestionnaireQuestionPayload,
} from "src-next/modules/questionnaire-builder/form-builder/types";

function getQuestionTypeLabel(type: QuestionnaireQuestionPayload["type"]): string {
  if (type === "shortText") return "Resposta curta";
  if (type === "longText") return "Resposta longa";
  if (type === "yesNo") return "Sim / Não";
  return "Múltipla escolha";
}

export interface AutomationLinkedQuestionnaireItemsProps {
  questionnaire: QuestionnairePayload;
}

const AutomationLinkedQuestionnaireItems = memo(
  ({ questionnaire }: AutomationLinkedQuestionnaireItemsProps) => {
    if (!questionnaire.questions.length) {
      return (
        <Typography variant="body2" color="text.secondary">
          Este questionário ainda não possui perguntas cadastradas.
        </Typography>
      );
    }

    return (
      <Stack spacing={1}>
        <Typography variant="body2" color="text.secondary">
          Perguntas do questionário ({questionnaire.questions.length})
        </Typography>
        <List
          dense
          disablePadding
          sx={{
            bgcolor: "action.hover",
            borderRadius: 1.5,
            maxHeight: 220,
            overflowY: "auto",
          }}
        >
          {questionnaire.questions.map((question, index) => (
            <ListItem
              key={question.id}
              divider={index < questionnaire.questions.length - 1}
              sx={{ py: 0.75 }}
            >
              <ListItemText
                primary={
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body2" fontWeight={500} sx={{ minWidth: 0 }}>
                      {index + 1}. {question.label || "Pergunta sem título"}
                    </Typography>
                    {question.isRequired ? (
                      <Chip label="Obrigatória" size="small" color="default" />
                    ) : null}
                  </Stack>
                }
                secondary={getQuestionTypeLabel(question.type)}
              />
            </ListItem>
          ))}
        </List>
      </Stack>
    );
  },
);

AutomationLinkedQuestionnaireItems.displayName = "AutomationLinkedQuestionnaireItems";

export default AutomationLinkedQuestionnaireItems;
